import React from "react";
import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { getListTest } from "../services";
import emptyIMG from "../../../media/empty.png";
import { EmptyState, Link } from "@shopify/polaris";
import dayjs from "dayjs";

const ListTestWriting = () => {
  const [listDataTest, setListDataTest] = React.useState([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [selectedType, setSelectedType] = React.useState<string>("all");

  React.useEffect(() => {
    setLoading(true);

    const params: any = {
      order_by: "DESC",
    };

    if (selectedType !== "all") {
      params.type = selectedType;
    }

    getListTest(params).then((res) => {
      if (!res?.isError) {
        setListDataTest(res);
      } else {
        alert("fail to fetch data");
      }
      setLoading(false);
    });
  }, [selectedType]);

  if (!loading && listDataTest.length == 0)
    return <EmptyState heading="Không có bài test nào!" image={emptyIMG} />;
  if (loading)
    return (
      <Box sx={{ display: "flex", flex: 1, justifyContent: "center", mt: 2 }}>
        <CircularProgress size={30} />
      </Box>
    );
  return (
    <Box
      sx={{
        margin: 2,
      }}
    >
      <FormControl sx={{ m: 2, minWidth: 200 }} size="small">
        <InputLabel id="type-select-label">Loại đề thi</InputLabel>
        <Select
          labelId="type-select-label"
          value={selectedType}
          label="Loại đề thi"
          onChange={(e) => setSelectedType(e.target.value)}
        >
          <MenuItem value="all">Tất cả</MenuItem>
          <MenuItem value="reading">Reading</MenuItem>
          <MenuItem value="listening">Listening</MenuItem>
          <MenuItem value="writing">Writing</MenuItem>
          <MenuItem value="speaking">Speaking</MenuItem>
        </Select>
      </FormControl>

      {listDataTest.map((item, index) => (
        <Link removeUnderline url={item._id}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              bgcolor: "#fff",
              padding: "8px 16px 8px 16px",
              borderRadius: "4px",
              boxShadow: "2px 4px 10px #ededeb",
            }}
            key={index}
          >
            <Typography variant="body1" fontWeight={700} color={"dodgerblue"}>
              {item.title}
            </Typography>
            <Typography variant="inherit" fontWeight={400}>
              {item.created_user_id.display_name}
            </Typography>
            <Typography variant="caption">
              {dayjs(item.createdAt).format("DD/MM/YYYY")}
            </Typography>
          </Box>
        </Link>
      ))}
    </Box>
  );
};

export default ListTestWriting;
